import { Image, Stack, Box ,Center} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Hourglass,ColorRing } from 'react-loader-spinner'
import { Track } from "livekit-client";

import { useGetState } from "../../../context/useGetState";
import {
  ControlBar,
  GridLayout,
  VideoTrack,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer,
  useTracks,
} from "@livekit/components-react";
import HostControls from "../../../components/livekit/host-controls";

import useSmallScreen from "../../../components/useSmallScreen";
import LiveStreamBottomControls from "./components/LiveStreamBottomControls";
import LiveStreamTopControls from "./components/LiveStreamTopControls";
import Chat from "../../../components/livekit/host-chat";

import axios from "axios";

const room = "superadmin-room";
const name = "";


function LiveStreamNow() {
  const { state } = useGetState();
  const location = useLocation();
  const _token = sessionStorage.getItem("#f8WEB#");
  const config = {
    headers: { Authorization: `Bearer ${_token}` }
};



  //livekit hard code
  const roomName = location?.state?.room
  const username =state?.userInfo?.username
  const url =state?.userInfo?.picture
  const description = location?.state?.description
  const cover = location?.state?.url

  const baseURL2 = "https://livestream-ruby.vercel.app/api/create-live-stream";
  //livekit 
  const serverUrl = "wss://pindodg-g5szeweq.livekit.cloud";
 let _id
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [smallScreen] = useSmallScreen();
  
  const [viewingLiveStream, setViewingLiveStream] = useState(false);
  // const { state } = useLocation();
  const [token, setToken] = React.useState(null);
  const [id, setId] = React.useState(null);
  
  useEffect(() => {
    const getOrCreateStreamerToken = async () => {
      if(username && roomName){
        const resp = await fetch(`http://104.237.2.75/api/host?room=${roomName}&username=${username}&url=${url}&cover=${cover}`);
        const data = await resp.json();
        setToken(data?.token);
    
        const rawResponse = await fetch('https://f8.codester.dev/api/create-live-stream', {
          method: 'POST',
          headers:new Headers({Authorization: `Bearer ${_token},`, 'Accept': 'application/json','Content-Type': 'application/json' }),

          body: JSON.stringify({title: location?.state?.room, description: location?.state?.description ,
            if_free:0,
            amount:0, host_id:state?.userInfo?.id})
        });
        const content = await rawResponse.json();
      _id=content?.data?.id
        setId( content?.data?.id);
        // setId(prevSelected => {
        //   // props.handle_card_selected(props.id, !prevSelected)
        //   return prevSelected= content?.data?.id
        // })
        console.log('fetch results-->',content?.data?.id,  _id)     

      }

      // const SESSION_STREAMER_TOKEN_KEY = `${location?.state?.room}-${state?.userInfo?.username}-streamer-token`;
      // const sessionToken = sessionStorage.getItem(SESSION_STREAMER_TOKEN_KEY);

      // if (sessionToken) {
      //   const payload = jwtDecode(sessionToken);

      //   if (payload.exp) {
      //     const expiry = new Date(payload.exp * 1000);
      //     if (expiry < new Date()) {
      //       sessionStorage.removeItem(SESSION_STREAMER_TOKEN_KEY);
      //       const token = await createStreamerToken(slug);
      //       setStreamerToken(token);
      //       sessionStorage.setItem(SESSION_STREAMER_TOKEN_KEY, token);
      //       return;
      //     }
      //   }

      //   setStreamerToken(sessionToken);
      // } else {
      //   const token = await createStreamerToken(slug);
      //   setStreamerToken(token);
      //   sessionStorage.setItem(SESSION_STREAMER_TOKEN_KEY, token);
      // }
    };
    void getOrCreateStreamerToken();
  //   return () => {

  //     const deleteToken = async () => {
  //       if(username && roomName){
  //                   const resp = await fetch(`https://livestream-ruby.vercel.app/api/host/delete?room=${roomName}&username=${username}`);
  //                   const data = await resp.json();
  
  //          console.log('id',id)
  //         const _rawResponse = await fetch(`https://f8.codester.dev/api/delete-live-stream/${_id}`, {
  //           method: 'DELETE',
  //           headers:new Headers({Authorization: `Bearer ${_token},` }),
  
  //         });
  //         const _content = await _rawResponse.json();
  //         console.log('fetch results-->',_content)     
  
  //       }
  
    
  //     };
  //     void deleteToken();
  // }
  }, [username]);


  useEffect(() => {

  }, [id]);
  // uncomment when livekit works
  // useEffect(() => {
  //   if (state?.viewer) {
  //     setViewingLiveStream(true);
  //   } else if (state?.presenter) {
  //     setViewingLiveStream(false);
  //   } else {
  //     window.history.back();
  //   }
  // }, [state]);

  const fullScreenStyles = {
    position: "fixed",
    w: "100vw",
    h: "100vh",
    left: "0",
    right: "0",
    top: "0",
    bottom: "0",
    zIndex: "1999",
  };

  const imgSizeStyle = {
    w: "100%",
    h: !smallScreen ? "100%" : "80vh",
  };

  if (token === '') {
    return <Center><ColorRing
    height="80"
    width="80"
    ariaLabel="loading"

  /></Center>;
  }


  return (
    
   
        
    <LiveKitRoom
      video={true}
      audio={true}
      token={token}
      serverUrl={'wss://pindodg-g5szeweq.livekit.cloud'}
      // Use the default LiveKit theme for nice styles.
      data-lk-theme="default"
      style={{ height: '85vh'
        // ,backgroundColor:'transparent',
        ,backgroundColor:'transparent',
        borderRadius:'20px',
     
       }}
    >
      {/* Your custom component with basic video conferencing functionality. */}
      <Box>
              <HostControls slug={roomName} />
            </Box>
      {/* <Chat 
       style={{ marginTop: -200 }}
        user={username}
        /> */}

      {/* The RoomAudioRenderer takes care of room-wide audio for you. */}
      <RoomAudioRenderer />
{/* 
             <LiveStreamTopControls
              viewingLiveStream={viewingLiveStream}
              setShowFullScreen={setShowFullScreen}
            /> */}

            <LiveStreamBottomControls
              showFullScreen={showFullScreen}
              roomName={roomName}
              username={username}
              viewingLiveStream={viewingLiveStream}
            />
      {/* Controls for the user to start/stop audio, video, and screen
      share tracks and to leave the room. */}
      {/* <ControlBar
       style={{ 
        // marginTop: -100,position:'fixed', right: 0
        right: 0,
        marginTop: -70,
        marginLeft:'45%',
        bottom:'100px'
       }}
        /> */}
    </LiveKitRoom>
  );
}
// function MyVideoConference() {
//   // `useTracks` returns all camera and screen share tracks. If a user
//   // joins without a published camera track, a placeholder track is returned.
//   const tracks = useTracks(
//     [
//       { source: Track.Source.Camera, withPlaceholder: true },
//       { source: Track.Source.ScreenShare, withPlaceholder: false },
//     ],
//     { onlySubscribed: false },
//   );  const trackRefs = useTracks([Track.Source.Camera]);
//   const tokyoCamTrackRef = trackRefs.find((trackRef) => trackRef?.participant?.identity === username);
  
//   return (
//     //@ts-ignore
//     <>{tokyoCamTrackRef ? <VideoTrack style={{ height: '80%' }} trackRef={tokyoCamTrackRef} /> : <div>Superadmin is offline</div>}</>

//   );
// }
export default LiveStreamNow;
